import React, { useState, useEffect, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import API from '../API';
// import ProjectName from "../components/form-inputs/project-name";
// import Description from '../components/form-inputs/description';
// import AddDetails from "./page-data/form/add-details";
// import Input from "../components/form-inputs/input";
import "./project-edit.css";
// import ErrorText from './error-msg';
import { Input } from 'antd';
const ProjectEdit = () => {
    const { id } = useParams();
    const history = useHistory();
    const layoutContent = useRef();
    
    const [state, setState] = useState({
        project_id: id,
        loaded: false,
        updateSuccess: false,
        loadingShow: false,
        questions: [],
        project: {},
        name_error: '',
        describtion_error: ''
    });

    useEffect(() => {
        fetchProjectDetails();
    }, []);

    const fetchProjectDetails = async () => {
        try {
            const response = await axios.get(
                `${API.baseURL}/projects/${id}/get_projects`,
                API.options
            );
            const res = response.data.data;
            setState(prev => ({
                ...prev,
                loaded: true,
                project: res.project,
                questions: res.questions,
            }));
        } catch (error) {
            // history.push('/project-not-found');
        }
    };

    const validate_form = () => {
        if (!state.project.name) {
            setState(prev => ({ ...prev, name_error: "Please give your project a name" }));
            return false;
        }
        if (!state.project.description) {
            setState(prev => ({ ...prev, describtion_error: "Please write a brief about your project" }));
            return false;
        }
        return true;
    };

    const saveProjectDetails = async () => {
        setState(prev => ({
            ...prev,
            name_error: "",
            describtion_error: ""
        }));

        if (validate_form()) {
            setState(prev => ({ ...prev, loadingShow: true }));

            const data = JSON.stringify({
                project: {
                    name: state.project.name,
                    description: state.project.description
                }
            });

            try {
                const response = await axios.patch(
                    `${API.baseURL}/projects/${id}/update_projects`,
                    data,
                    API.options
                );
                if (response.status === 200) {
                    window.location=`/project-detail/${id}/my_projects`;
                }
            } catch (error) {
                // Handle error
            }
        }
    };

    const changeHandler = (event) => {
        const { name, value } = event.target;
        setState(prev => ({
            ...prev,
            project: {
                ...prev.project,
                [name]: value
            }
        }));
    };

    const headerProps = {
        top: { left: {}, right: {} },
        middle: {
            left: { PageTitle: "Edit Project" },
            right: {}
        },
        bottom: {},
        headClasses: "ec-404__header"
    };

    const bodyProps = {
        bodyClasses: "ec-pform__body"
    };

    return (
        <div style={{paddingTop: '120px'}}>
            {state.loaded ? (
                <div className="ec-pform__body-inwrap">
                    <div className="ec-pform__section ec-pform__section--describe-your-project">
                        <div className="edit-form-card">
                            <Input
                                name="name"
                                value={state.project.name}
                                onChange={changeHandler}
                                placeholder="Enter project name"
                                style={{
                                    marginBottom: '20px',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    fontSize: '16px'
                                }}
                                label={<div className="form-label">Project Name</div>}
                                error={state.name_error}
                            />

                            <Input.TextArea
                                name="description"
                                value={state.project.description}
                                onChange={changeHandler}
                                placeholder="Enter more information here..."
                                style={{
                                    marginBottom: '20px',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    fontSize: '16px',
                                    minHeight: '120px'
                                }}
                                label={<div className="form-label">Enter if you have any information</div>}
                                error={state.describtion_error}
                            />
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <button 
                                    onClick={saveProjectDetails}
                                    className="update-button"
                                >
                                    UPDATE
                                </button>
                            </div>
                        </div>

                        {state.loadingShow && (
                            <div style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 1000
                            }}>
                                <div style={{
                                    backgroundColor: 'white',
                                    padding: '20px',
                                    borderRadius: '8px',
                                    textAlign: 'center'
                                }}>
                                    Updating Details. Please wait...
                                </div>
                            </div>
                        )}

                        {/* {state.updateSuccess && (
                            <div style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 1000
                            }}>
                                <div style={{
                                    backgroundColor: 'white',
                                    padding: '20px',
                                    borderRadius: '8px',
                                    minWidth: '300px'
                                }}>
                                    <h3 style={{ marginTop: 0 }}>Project Updated Successfully.</h3>
                                    <button 
                                        onClick={() => history.goBack()}
                                        style={{
                                            padding: '8px 16px',
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Okay
                                    </button>
                                </div>
                            </div>
                        )} */}
                    </div>
                </div>
            ) : (
                <div style={{ 
                    minHeight: "calc(100vh - 100px)", 
                    paddingTop: "120px", 
                    display: "flex", 
                    flexDirection: "column",
                    justifyContent: "center", 
                    alignItems: "center",
                    gap: "20px"
                }}>
                    <div className="loading-spinner" style={{
                        width: "40px",
                        height: "40px",
                        border: "3px solid #f3f3f3",
                        borderTop: "3px solid #3498db",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite"
                    }}></div>
                    <div style={{
                        fontSize: "18px",
                        color: "#666",
                        textAlign: "center"
                    }}>
                        <div>Loading project details</div>
                        <div style={{fontSize: "14px", marginTop: "5px"}}>This may take a moment...</div>
                    </div>
                    <style>
                        {`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}
                    </style>
                </div>
            )}
        </div>
    );
};

export default ProjectEdit; 